import request from '@/utils/request'

const tradeSettlementApi = {
  trade_settlement_list: '/trade/settlement/',
  trade_settlement_create: '/trade/settlement/',
  trade_settlement_update: '/trade/settlement/',
  trade_settlement_delete: '/trade/settlement/',
  trade_settlement_archived: '/trade/settlement_archived/',
  trade_settlement_attachment: '/trade/settlement_attachment/',
  trade_settlement_product_parameter_list: '/trade/settlement_product_parameter/'
}

/**
 * 列表
 */
export function settlement_list (parameter) {
  return request({
    url: tradeSettlementApi.trade_settlement_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function settlement_create (parameter) {
  return request({
    url: tradeSettlementApi.trade_settlement_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function settlement_update (parameter, settlement_id) {
  return request({
    url: tradeSettlementApi.trade_settlement_update + settlement_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function settlement_delete (settlement_id) {
  return request({
    url: tradeSettlementApi.trade_settlement_delete + settlement_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function settlement_archived (parameter) {
  return request({
    url: tradeSettlementApi.trade_settlement_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 列表
 */
export function settlement_product_parameter_list (parameter) {
  return request({
    url: tradeSettlementApi.trade_settlement_product_parameter_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 列表
 */
export function settlement_attachment_list (parameter) {
  return request({
    url: tradeSettlementApi.trade_settlement_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

export function settlement_attachment_create (parameter) {
  return request({
    url: tradeSettlementApi.trade_settlement_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function settlement_attachment_delete (attachment_id) {
  return request({
    url: tradeSettlementApi.trade_settlement_attachment + attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function settlement_attachment_update (parameter, settlement_id) {
  return request({
    url: tradeSettlementApi.trade_settlement_attachment + settlement_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
